import React from 'react';
import Head from 'next/head';
import useMeQuery from '@hooks/useMeQuery';
import DefaultFavicon from '../../../public/images/favicon.png';

const Favicon = () => {
  const { data } = useMeQuery();
  const faviconUrl =
    data?.me?.event?.accountConfig?.faviconUrl || DefaultFavicon;

  return (
    <Head>
      <link key="favicon" rel="shortcut icon" href={faviconUrl} />
    </Head>
  );
};

export default Favicon;
